import { COST_CENTERS } from "..";
import { apiInstance } from "../config/apiInstance";

export const deleteCostCenter = async (id: number): Promise<void> => {
  await apiInstance.delete(`${COST_CENTERS}/${id}`);
};
